import { useTheme } from '@mui/material';

export const useSxStyles = () => {
  const theme = useTheme();

  return {
    formContent: {
      display: 'flex',
      flexDirection: 'column',
      gap: theme.spacing(2),
    },
    divider: {
      margin: theme.spacing(2, 0),
    },
    formFieldWithAction: {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'flex-start',
      gap: theme.spacing(2),
    },
  };
};
